<template>
  <div class="guarantor-new">
    <Row :gutter="16">
      <i-col span="16" offset="4">
        <Form ref="newForm" :model="projectModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <Collapse simple :value="['project','owner','contractor','supervisory','distributor']">
            <Panel name="project" v-if="projectModel.project">
              项目基本信息
              <div slot="content">
                <FormItem label="名称" prop="project.name">
                  <!-- <Select
                    v-model="projectModel.project.name"
                    filterable
                    allow-create
                    @on-create="createPrjName"
                    @on-select="selectProject"
                    @on-change="queryProjectChange"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchProjects"
                    :loading="loading"> -->
                  <Select
                    v-model="projectModel.project.name"
                    filterable
                    @on-select="selectProject"
                    @on-change="queryProjectChange"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchProjects"
                    :loading="loading">
                    <Option v-for="(option, index) in projects" :value="option.name" :tag="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                  <span class="small font-grey">
                    找不到项目？<Button type="primary" ghost @click="showAddNewPrjModal=true">新增项目</Button>
                  </span>
                  <!-- <Input v-model="projectModel.name" placeholder="输入名称" /> -->
                </FormItem>
                <FormItem label="项目立项备案号" prop="project.filingNo" v-if="projectModel.project.name">
                  <Input v-model="projectModel.project.filingNo" placeholder="输入项目立项备案号" />
                </FormItem>
                <FormItem label="规划许可证号" prop="project.planLicenseNo" v-if="projectModel.project.name">
                  <Input v-model="projectModel.project.planLicenseNo" placeholder="输入规划许可证号" />
                </FormItem>
                <FormItem label="施工许可证号" prop="project.constrLicenceNo" v-if="projectModel.project.name">
                  <Input v-model="projectModel.project.constrLicenceNo" placeholder="输入施工许可证号" />
                </FormItem>
                <FormItem label="土地使用证编号" prop="project.landLicenceNo" v-if="projectModel.project.name">
                  <Input v-model="projectModel.project.landLicenceNo" placeholder="输入土地使用证编号" />
                </FormItem>
                <FormItem label="类型" prop="project.type" v-if="projectModel.project.name">
                  <Cascader v-model="prjTypeCur" :data="prjTypeSelect" v-if="prjTypeSelect&&prjTypeSelect.length"  @on-change="prjTypeSelected" placeholder="选择"></Cascader>
                  <!-- <Select v-model="projectModel.type" filterable>
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.companyType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select> -->
                </FormItem>
                <FormItem label="工程造价(元)" prop="project.cost" v-if="projectModel.project.name">
                  <InputNumber :min="0" :step="10000"
                    style="width: 150px;display:inline-block"
                    v-model="projectModel.project.cost"
                    placeholder="输入工程造价(元)"></InputNumber>
                  <Divider type="vertical" v-if="projectModel.project.cost" />
                  <h3 style="display:inline-block" v-if="projectModel.project.cost"> {{`¥ ${projectModel.project.cost}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
                  <Divider type="vertical" v-if="projectModel.project.cost" />
                  <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(projectModel.project.cost)}}</h3>
                </FormItem>
                <FormItem label="建设规模" prop="project.area" v-if="projectModel.project.name">
                  <InputNumber :min="0" :step="10000" style="width: 200px" v-model="projectModel.project.area" placeholder="输入建设规模(m/m²/m³)"></InputNumber>
                </FormItem>
                <FormItem label="开竣工日期" prop="project.startdate" v-if="projectModel.project.name">
                  <DatePicker v-model="projectModel.project.daterange"
                    @on-change="prjDateChange"
                    type="daterange"
                    placement="bottom-end"
                    format="yyyy/MM/dd"
                    placeholder="选择开竣工日期"
                    style="width: 100%"></DatePicker>
                </FormItem>
                <FormItem label="工期(天)" prop="project.duration" v-if="projectModel.project.name">
                  <Input v-model="projectModel.project.duration" placeholder="工期天数" />
                </FormItem>
                <FormItem label="质量要求" prop="project.qualityRequirement" v-if="projectModel.project.name">
                  <Input v-model="projectModel.project.qualityRequirement" placeholder="质量要求" />
                </FormItem>
              </div>
            </Panel>
            <Panel name="owner" v-if="projectModel.owner">
              业主信息
              <div slot="content">
                <FormItem label="名称" prop="owner.name">
                  <!-- <Input v-model="projectModel.owner.name" placeholder="输入名称" /> -->
                  <Select
                    v-model="projectModel.owner.name"
                    filterable
                    remote
                    @on-select="selectOwner"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchOwners"
                    :loading="loading">
                    <Option v-for="(option, index) in owners" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
                  </Select>
                  <span class="small font-grey">
                    <Button type="primary" ghost @click="showNewCompanyModal(4)">新增业主</Button>
                  </span>
                </FormItem>
                <FormItem label="社会信用代码" prop="owner.businessLicense" v-if="projectModel.owner.name">
                  <Input v-model="projectModel.owner.businessLicense" placeholder="输入社会信用代码" />
                </FormItem>
                <FormItem label="法人姓名" prop="owner.legalPersonName" v-if="projectModel.owner.name">
                  <Input v-model="projectModel.owner.legalPersonName" placeholder="输入法人姓名" />
                </FormItem>
                <FormItem label="是否本省" prop="owner.isLocal" v-if="projectModel.owner.name">
                  <i-switch v-model="projectModel.owner.isLocal" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="城市" prop="owner.regCity" v-if="projectModel.owner.name&&projectModel.owner.isLocal">
                  <Cascader :data="cities" :load-data="loadCityData" @on-change="contractorCitySelected" placeholder="选择城市"></Cascader>
                </FormItem>
                <FormItem label="营业地址" prop="owner.address" v-if="projectModel.owner.name">
                  <Input v-model="projectModel.owner.address" placeholder="输入营业地址" />
                </FormItem>
                <FormItem label="电子邮件" prop="owner.email" v-if="projectModel.owner.name">
                  <Input v-model="projectModel.owner.email" placeholder="输入电子邮件" />
                </FormItem>
                <FormItem label="联系人" prop="owner.contact" v-if="projectModel.owner.name">
                  <Input v-model="projectModel.owner.contact" placeholder="输入联系人" />
                </FormItem>
                <FormItem label="联系人电话" prop="contactTel" v-if="projectModel.owner.name">
                  <Input v-model="projectModel.owner.contactTel" placeholder="输入联系人电话" />
                </FormItem>
              </div>
            </Panel>
            <Panel name="contractor" v-if="projectModel.contractor">
              总承包信息
              <div slot="content">
                <FormItem label="名称" prop="contractor.name">
                  <!-- <Input v-model="projectModel.owner.name" placeholder="输入名称" /> -->
                  <Select
                    v-model="projectModel.contractor.name"
                    filterable
                    remote
                    @on-select="selectContractor"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchContractors"
                    :loading="loading">
                    <Option v-for="(option, index) in contractors" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
                  </Select>
                  <span class="small font-grey">
                    <Button type="primary" ghost @click="showNewCompanyModal(1)">新增总承包</Button>
                  </span>
                </FormItem>
                <FormItem label="社会信用代码" prop="contractor.businessLicense" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractor.businessLicense" placeholder="输入社会信用代码" />
                </FormItem>
                <FormItem label="法人姓名" prop="contractor.legalPersonName" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractor.legalPersonName" placeholder="输入法人姓名" />
                </FormItem>
                <FormItem label="合同备案号" prop="contractorContractNo" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractorContractNo" placeholder="输入承包商合同备案号" />
                </FormItem>
                <FormItem label="是否本省" prop="contractor.isLocal" v-if="projectModel.contractor.name">
                  <i-switch v-model="projectModel.contractor.isLocal" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="城市" prop="contractor.regCity" v-if="projectModel.contractor.isLocal&&projectModel.contractor.name">
                  <Cascader :data="cities" :load-data="loadCityData" @on-change="ownerCitySelected" placeholder="选择城市"></Cascader>
                </FormItem>
                <FormItem label="营业地址" prop="contractor.address" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractor.address" placeholder="输入营业地址" />
                </FormItem>
                <FormItem label="电子邮件" prop="contractor.email" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractor.email" placeholder="输入电子邮件" />
                </FormItem>
                <FormItem label="联系人" prop="contractor.contact" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractor.contact" placeholder="输入联系人" />
                </FormItem>
                <FormItem label="联系人电话" prop="contractor.contactTel" v-if="projectModel.contractor.name">
                  <Input v-model="projectModel.contractor.contactTel" placeholder="输入联系人电话" />
                </FormItem>
              </div>
            </Panel>
            <Panel name="supervisory" v-if="projectModel.supervisory">
              监理企业信息
              <div slot="content">
                <FormItem label="名称" prop="supervisory.name">
                  <!-- <Input v-model="projectModel.owner.name" placeholder="输入名称" /> -->
                  <Select
                    v-model="projectModel.supervisory.name"
                    filterable
                    remote
                    @on-select="selectSupervisory"
                    placeholder="输入关键字选择或键入完整名称"
                    :remote-method="searchSupervisories"
                    :loading="loading">
                    <Option v-for="(option, index) in supervisories" :value="option.name" :tag="option.tid" :key="index">{{option.name}}</Option>
                  </Select>
                  <span class="small font-grey">
                    <Button type="primary" ghost @click="showNewCompanyModal(5)">新增监理企业</Button>
                  </span>
                </FormItem>
                <FormItem label="社会信用代码" prop="supervisory.businessLicense" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisory.businessLicense" placeholder="输入社会信用代码" />
                </FormItem>
                <FormItem label="法人姓名" prop="supervisory.legalPersonName" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisory.legalPersonName" placeholder="输入法人姓名" />
                </FormItem>
                <FormItem label="合同备案号" prop="supervisoryContractNo" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisoryContractNo" placeholder="输入承包商合同备案号" />
                </FormItem>
                <FormItem label="是否本省" prop="supervisory.isLocal" v-if="projectModel.supervisory.name">
                  <i-switch v-model="projectModel.supervisory.isLocal" size="large">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
                <FormItem label="城市" prop="supervisory.regCity" v-if="projectModel.supervisory.isLocal&&projectModel.supervisory.name">
                  <Cascader :data="cities" :load-data="loadCityData" @on-change="supervisoryCitySelected" placeholder="选择城市"></Cascader>
                </FormItem>
                <FormItem label="营业地址" prop="supervisory.address" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisory.address" placeholder="输入营业地址" />
                </FormItem>
                <FormItem label="电子邮件" prop="supervisory.email" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisory.email" placeholder="输入电子邮件" />
                </FormItem>
                <FormItem label="联系人" prop="supervisory.contact" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisory.contact" placeholder="输入联系人" />
                </FormItem>
                <FormItem label="联系人电话" prop="supervisory.contactTel" v-if="projectModel.supervisory.name">
                  <Input v-model="projectModel.supervisory.contactTel" placeholder="输入联系人电话" />
                </FormItem>
              </div>
            </Panel>
            <Panel name="distributor" v-if="projectModel.distributor">
              劳务分包信息
              <div slot="content">
                <FormItem label="合同备案号" prop="distributorContractNo">
                  <Input v-model="projectModel.distributorContractNo" placeholder="输入劳务分包合同备案号" />
                </FormItem>
                <FormItem label="负责人姓名" prop="distributorIncharge">
                  <Input v-model="projectModel.distributorIncharge" placeholder="输入分包负责人姓名" />
                </FormItem>
                <FormItem label="身份证号" prop="distributorInchargeId">
                  <Input v-model="projectModel.distributorInchargeId" placeholder="输入分包责任人身份证号" />
                </FormItem>
                <FormItem label="联系人" prop="distributorContact">
                  <Input v-model="projectModel.distributorContact" placeholder="输入分包责任人联系人" />
                </FormItem>
                <FormItem label="联系电话" prop="distributorTel">
                  <Input v-model="projectModel.distributorTel" placeholder="输入分包责任人联系电话" />
                </FormItem>
                <FormItem label="地址" prop="distributorAddr">
                  <Input v-model="projectModel.distributorAddr" placeholder="输入分包责任人地址" />
                </FormItem>
                <FormItem label="电子邮件" prop="distributorEmail">
                  <Input v-model="projectModel.distributorEmail" placeholder="输入分包责任人电子邮件" />
                </FormItem>
              </div>
            </Panel>
          </Collapse>
          <div class="padding-top-20"></div>
          <Row :gutter="16">
            <Col span="4"><Button type="warning" size="large" style="display:inline" @click="backward">上一步</Button></Col>
            <Col span="20"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
          </Row>
        </Form>
      </i-col>
    </Row>
    <addNewPrjModal
      :show="showAddNewPrjModal"
      :cityId="projectModel.cityId"
      @finished="newProjectCallback"
      @close="showAddNewPrjModal=false" />
    <addNewCompanyModal
      :show="showAddNewCompanyModal"
      :type="showAddNewCompanyType"
      @finished="newCompanyCallback"
      @close="showAddNewCompanyModal=false" />
  </div>
</template>

<script>
import Api from './../../api/Api.js'
import addNewPrjModal from './../Projects/AddNewModal'
import addNewCompanyModal from './../Companies/AddNewModal'
export default {
  name: 'guarantor-new',
  props: {
    data: Object
  },
  components: {
    addNewPrjModal,
    addNewCompanyModal
  },
  data () {
    return {
      loading: false,
      showAddNewPrjModal: false,
      showAddNewCompanyModal: false,
      showAddNewCompanyType: null,
      projectModel: {
        prjId: null,
        cityId: null,
        project: {
          id: null,
          name: null,
          type: null,
          filingNo: null,
          planLicenseNo: null,
          constrLicenceNo: null,
          landLiceceNo: null,
          cityCode: null,
          cityId: null,
          cities: null,
          area: null,
          cost: null,
          site: null,
          startdate: null,
          finishdate: null,
          daterange: null,
          duration: null,
          qualityRequirement: null
        },
        ownerId: null,
        owner: {
          name: null,
          businessLicense: null,
          legalPersonName: null,
          contact: null,
          contactTel: null,
          regCity: null,
          address: null,
          email: null,
          isLocal: true,
          type: 4
        },
        contractorId: null,
        contractor: {
          name: null,
          businessLicense: null,
          legalPersonName: null,
          contact: null,
          contactTel: null,
          regCity: null,
          address: null,
          email: null,
          isLocal: true,
          type: 1
        },
        contractorContractNo: null,
        contractorType: 1,
        supervisoryId: null,
        supervisory: {
          name: null,
          businessLicense: null,
          legalPersonName: null,
          contact: null,
          contactTel: null,
          regCity: null,
          address: null,
          email: null,
          isLocal: true,
          type: 1
        },
        supervisoryContractNo: null,
        distributorIncharge: null,
        distributorInchargeId: null,
        distributorContact: null,
        distributorTel: null,
        distributorAddr: null,
        distributorEmail: null,
        distributorContractNo: null
      },
      modelValidate: {
        'project.name': [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        'project.cityId': [
          { required: true, type: 'number', message: '请选择项目所在地', trigger: 'blur' }
        ],
        'project.cost': [
          { required: true, type: 'number', message: '请填写造价', trigger: 'blur' }
        ],
        'project.startdate': [
          { required: true, message: '请填写开工日期', trigger: 'blur' }
        ],
        'project.planLicenseNo': [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        'project.constrLicenceNo': [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        'project.type': [
          { required: true, type: 'number', message: '请选择', trigger: 'blur' }
        ],
        ownerId: [
          { required: true, type: 'number', message: '请填写业主信息', trigger: 'blur' }
        ],
        'owner.name': [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        'owner.businessLicense': [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        'owner.legalPersonName': [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        contractorId: [
          { required: true, type: 'number', message: '请填写总承包商信息', trigger: 'blur' }
        ],
        'contractor.name': [
          { required: true, message: '请填写总承包商名称', trigger: 'blur' }
        ],
        'contractor.businessLicense': [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        'contractor.legalPersonName': [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        'contractor.contact': [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        'contractor.contactTel': [
          { required: true, message: '请填写', trigger: 'blur' }
        ]
        // supervisoryId: [
        //   { required: true, type: 'number', message: '请填写监理企业信息', trigger: 'blur' }
        // ],
        // 'supervisory.name': [
        //   { required: true, message: '请填写监理企业名称', trigger: 'blur' }
        // ],
        // 'supervisory.businessLicense': [
        //   { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        // ],
        // 'supervisory.legalPersonName': [
        //   { required: true, message: '请填写', trigger: 'blur' }
        // ],
        // 'supervisory.contact': [
        //   { required: true, message: '请填写', trigger: 'blur' }
        // ],
        // 'supervisory.contactTel': [
        //   { required: true, message: '请填写', trigger: 'blur' }
        // ]
        // 'distributorIncharge': [
        //   { required: true, message: '请填写', trigger: 'blur' }
        // ],
        // 'distributorContact': [
        //   { required: true, message: '请填写', trigger: 'blur' }
        // ],
        // 'distributorTel': [
        //   { required: true, message: '请填写', trigger: 'blur' }
        // ]
      },
      cities: [],
      projects: [],
      baseProject: null,
      prjTypes: [],
      prjTypeSelect: null,
      prjTypeCur: [],
      owners: [],
      baseOwner: null,
      contractors: [],
      baseContractor: null,
      supervisories: [],
      baseSupervisory: null
    }
  },
  watch: {
  },
  mounted () {
    this.initCitySelect()
    this.prjCascadeValues = []
    if (!this.data.cityId) {
      this.$router.push({path: '/guarantees/new/step1'})
    } else {
      console.log(111)
      if (this.data.project) {
        Object.assign(this.projectModel, this.data)
        console.log(this.projectModel, this.projectModel.project.name)
        this.baseProject = JSON.parse(JSON.stringify(this.data.project))
        this.baseOwner = this.data.owner ? JSON.parse(JSON.stringify(this.data.owner)) : null
        this.baseContractor = this.data.contractor ? JSON.parse(JSON.stringify(this.data.contractor)) : null
        this.baseSupervisory = this.data.supervisory ? JSON.parse(JSON.stringify(this.data.supervisory)) : null
        this.projectModel.project.daterange = [
          this.baseProject.startdate,
          this.baseProject.finishdate
        ]
      }
      this.projectModel.cityId = this.data.cityId
      this.projectModel.project.cityId = this.data.cityId
    }
    this.initPrjTypes().then((list) => {
      this.prjTypeSelect = this.prepPrjTypeCascader(list, this.projectModel.project.type)
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    backward () {
      this.$emit('go-backward')
    },
    selectProject (prj) {
      console.log(prj, typeof(prj.value))
      try {
        if (prj.tag) {
          this.baseProject = JSON.parse(JSON.stringify(this.projects.find(o => o.id === prj.tag)))
          this.projectModel.prjId = this.baseProject.id
          this.baseProject.cost = this.baseProject.cost / 100
          // console.log(this.projectModel.project.cost, this.baseProject.cost)
          this.projectModel.project.daterange = [
            this.baseProject.startdate,
            this.baseProject.finishdate
          ]
          if (this.baseProject.type) {
            let prjType = this.prjTypes.find(o => o.tid === this.baseProject.type)
            // console.log(this.baseProject, prjType)
            this.prjTypeCur = [prjType.tid]
            if (prjType.parentNode) {
              let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
              // console.log(parentNode)
              this.prjTypeCur.splice(0, 0, parentNode.tid)
            }
          }
          let project = this.projectModel.project
          Object.assign(project, this.baseProject)
          // console.log(project)
        } else {
          this.projectModel.project.name = prj.value
          this.projectModel.project.cost = this.baseProject ? this.baseProject.cost : 0
        }
      } catch (e) {
        console.log(e)
        this.projectModel.project.name = prj.value
      }
    },
    createPrjName (query) {
      console.log(query, this.projects)
      this.projects.push({
        name: query,
        id: 0
      })
    },
    searchProjects (query) {
      Api.Project.searchProjects({
        name: query,
        cityId: this.data.cityId
      }, 1, 1000).then((prjs) => {
        this.projects = prjs.data
      }).catch(err => {
        this.$Message.error('获取项目列表失败!' + err.message)
      })
    },
    queryProjectChange (query) {
      console.log(query)
    },
    newProjectCallback (project) {
      if (project && project.id) {
        project.cost /= 100
        this.projectModel.prjId = project.id
        if (project.type) {
          let prjType = this.prjTypes.find(o => o.tid === project.type)
          // console.log(this.baseProject, prjType)
          this.prjTypeCur = [prjType.tid]
          if (prjType.parentNode) {
            let parentNode = this.prjTypes.find(o => o.tid === prjType.parentNode)
            // console.log(parentNode)
            this.prjTypeCur.splice(0, 0, parentNode.tid)
          }
        }
        this.baseProject = project
        Object.assign(this.projectModel.project, project)
      }
      this.showAddNewPrjModal = false
    },
    showNewCompanyModal (type) {
      this.showAddNewCompanyModal = true
      this.showAddNewCompanyType = type
    },
    newCompanyCallback (company) {
      if (company && company.tid) {
        switch (company.type) {
          case 4:
            this.projectModel.ownerId = company.tid
            this.baseOwner = company
            Object.assign(this.projectModel.owner, company)
            break
          case 1:
            this.baseContractor = company
            this.projectModel.contractorId = company.tid
            Object.assign(this.projectModel.contractor, company)
            break
          case 5:
            this.baseSupervisory = company
            this.projectModel.supervisoryId = company.tid
            Object.assign(this.projectModel.supervisory, company)
            break  
        }
      }
      this.showAddNewCompanyModal = false
    },
    selectOwner (own) {
      console.log(own, typeof(own.value))
      try {
        if (own.tag) {
          this.baseOwner = JSON.parse(JSON.stringify(this.owners.find(o => o.tid === own.tag)))
          this.projectModel.ownerId = own.tag
          Object.assign(this.projectModel.owner, this.baseOwner)
        } else {
          this.projectModel.owner.name = own.value
        }
      } catch (e) {
        console.log(e)
        this.projectModel.owner.name = own.value
      }
    },
    createOwnerName (query) {
      this.owners.push({
        name: query,
        id: 0
      })
    },
    searchOwners (query) {
      Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 4
      }, 1, 1000).then((companies) => {
        this.owners = companies.data
      }).catch(err => {
        this.$Message.error('获取业主列表失败!' + err.message)
      })
    },
    selectContractor (company) {
      console.log(company, typeof(company.value))
      try {
        if (company.tag) {
          this.baseContractor = JSON.parse(JSON.stringify(this.contractors.find(o => o.tid === company.tag)))
          this.projectModel.contractorId = company.tag
          Object.assign(this.projectModel.contractor, this.baseContractor)
        } else {
          this.projectModel.contractor.name = company.value
        }
      } catch (e) {
        console.log(e)
        this.projectModel.contractor.name = company.value
      }
    },
    createContractorName (query) {
      this.contractors.push({
        name: query,
        id: 0
      })
    },
    searchContractors (query) {
      Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 1
      }, 1, 1000).then((companies) => {
        this.contractors = companies.data
      }).catch(err => {
        this.$Message.error('获取承包商列表失败!' + err.message)
      })
    },
    selectSupervisory (company) {
      console.log(company, typeof(company.value))
      try {
        if (company.tag) {
          this.baseSupervisory = JSON.parse(JSON.stringify(this.supervisories.find(o => o.tid === company.tag)))
          this.projectModel.supervisoryId = company.tag
          Object.assign(this.projectModel.supervisory, this.baseSupervisory)
        } else {
          this.projectModel.supervisory.name = company.value
        }
      } catch (e) {
        console.log(e)
        this.projectModel.supervisory.name = company.value
      }
    },
    createSupervisoryName (query) {
      this.supervisories.push({
        name: query,
        id: 0
      })
    },
    searchSupervisories (query) {
      Api.Company.listCompanies({
        isLocal: null,
        name: query,
        type: 5
      }, 1, 1000).then((companies) => {
        this.supervisories = companies.data
      }).catch(err => {
        this.$Message.error('获取监理企业列表失败!' + err.message)
      })
    },
    prjDateChange (date) {
      console.log(date)
      if (date && date instanceof Array && date.length === 2) {
        this.projectModel.project.startdate = require('moment')(date[0]).format('YYYY-MM-DD')
        this.projectModel.project.finishdate = require('moment')(date[1]).format('YYYY-MM-DD')
        this.projectModel.project.duration = parseInt(require('moment')(date[1]).diff(require('moment')(date[0]), 'days'))
      }
    },
    async initPrjTypes () {
      return new Promise((resolve, reject) => {
        this.$Spin.show()
        this.$Api.Project.getPrjTypes().then(res => {
          this.prjTypes = res
          this.$Spin.hide()
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          this.$Spin.hide()
          reject(err)
        })
      })
    },
    prepPrjTypeCascader (list, initVal) {
      let data = []
      let topTier = list.filter(o => {
        return o.parentNode === null
      })
      topTier.forEach((t1) => {
        let tierId = t1.tid
        if (tierId === initVal) {
          this.prjTypeCur.push(tierId)
        }
        if (!t1.children) {
          t1.children = []
        }
        let secondTier = list.filter(o => {
          return o.parentNode === tierId
        })
        secondTier.forEach((t2) => {
          if (t2.tid === initVal) {
            this.prjTypeCur.push(tierId)
            this.prjTypeCur.push(t2.tid)
          }
          t1.children.push({
            label: t2.prjType,
            value: t2.tid,
            tid: t2.tid
          })
        })
        data.push({
          label: t1.prjType,
          value: t1.tid,
          tid: t1.tid,
          children: t1.children
        })
      })
      return data
    },
    prjTypeSelected (val) {
      if (val instanceof Array) {
        this.projectModel.project.type = val[val.length - 1]
      } else {
        this.projectModel.project.type = val
      }
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    ownerCitySelected (val) {
      if (val instanceof Array) {
        this.projectModel.owner.cityId = val[val.length - 1]
      } else {
        this.projectModel.owner.cityId = val
      }
    },
    contractorCitySelected (val) {
      if (val instanceof Array) {
        this.projectModel.contractor.cityId = val[val.length - 1]
      } else {
        this.projectModel.contractor.cityId = val
      }
    },
    supervisoryCitySelected (val) {
      if (val instanceof Array) {
        this.projectModel.supervisory.cityId = val[val.length - 1]
      } else {
        this.projectModel.supervisory.cityId = val
      }
    },
    submitNewOwner () {
      return new Promise((resolve, reject) => {
        if (!this.baseOwner || this.projectModel.owner.tid !== this.baseOwner.tid ||
          this.projectModel.owner.name !== this.baseOwner.name) {
          // 新增
          Api.Company.addCompany(this.projectModel.owner).then(result => {
            if (typeof(result) === 'object') {
              this.$Message.error('新增业主失败![数据模型错误]')
              reject(new Error('数据模型错误'))
            }
            this.projectModel.owner.tid = result
            this.projectModel.ownerId = result
            resolve()
          }).catch(err => {
            reject(err)
          })
        } else if (
          this.projectModel.owner.businessLicense !== this.baseOwner.businessLicense ||
          this.projectModel.owner.contact !== this.baseOwner.contact ||
          this.projectModel.owner.contactTel !== this.baseOwner.contactTel ||
          this.projectModel.owner.regCity !== this.baseOwner.regCity ||
          this.projectModel.owner.address !== this.baseOwner.address ||
          this.projectModel.owner.email !== this.baseOwner.email ||
          this.projectModel.owner.isLocal !== this.baseOwner.isLocal) {
          // 修改
          Api.Company.updateCompany(this.projectModel.owner).then(() => {
            resolve()
          }).catch(err => {
            this.$Message.error('更新业主失败!' + err.message)
            reject(err)
          })
        } else {
          resolve()
        }
      })
    },
    submitNewContractor () {
      return new Promise((resolve, reject) => {
        if (!this.baseContractor || this.projectModel.contractor.tid !== this.baseContractor.tid ||
          this.projectModel.contractor.name !== this.baseContractor.name) {
          // 新增
          Api.Company.addCompany(this.projectModel.contractor).then(result => {
            if (typeof(result) === 'object') {
              this.$Message.error('新增总承包商失败![数据模型错误]')
              reject(new Error('数据模型错误'))
            }
            this.projectModel.contractor.tid = result
            this.projectModel.contractorId = result
            resolve()
          }).catch(err => {
            this.$Message.error('新增总承包商失败!' + err.message)
            reject(err)
          })
        } else if (
          this.projectModel.contractor.businessLicense !== this.baseContractor.businessLicense ||
          this.projectModel.contractor.contact !== this.baseContractor.contact ||
          this.projectModel.contractor.contactTel !== this.baseContractor.contactTel ||
          this.projectModel.contractor.regCity !== this.baseContractor.regCity ||
          this.projectModel.contractor.address !== this.baseContractor.address ||
          this.projectModel.contractor.email !== this.baseContractor.email ||
          this.projectModel.contractor.isLocal !== this.baseContractor.isLocal) {
          // 修改
          Api.Company.updateCompany(this.projectModel.contractor).then(() => {
            resolve()
          }).catch(err => {
            this.$Message.error('更新总承包商失败!' + err.message)
            reject(err)
          })
        } else {
          resolve()
        }
      })
    },
    submitNewSupervisory () {
      return new Promise((resolve, reject) => {
        if (!this.baseSupervisory) {
          resolve()
        }
        if (this.projectModel.supervisory.tid !== this.baseSupervisory.tid ||
          this.projectModel.supervisory.name !== this.baseSupervisory.name) {
          // 新增
          Api.Company.addCompany(this.projectModel.supervisory).then(result => {
            if (typeof(result) === 'object') {
              this.$Message.error('新增监理企业失败![数据模型错误]')
              reject(new Error('数据模型错误'))
            }
            this.projectModel.supervisory.tid = result
            this.projectModel.supervisoryId = result
            resolve()
          }).catch(err => {
            this.$Message.error('新增监理企业失败!' + err.message)
            reject(err)
          })
        } else if (
          this.projectModel.supervisory.businessLicense !== this.baseSupervisory.businessLicense ||
          this.projectModel.supervisory.contact !== this.baseSupervisory.contact ||
          this.projectModel.supervisory.contactTel !== this.baseSupervisory.contactTel ||
          this.projectModel.supervisory.regCity !== this.baseSupervisory.regCity ||
          this.projectModel.supervisory.address !== this.baseSupervisory.address ||
          this.projectModel.supervisory.email !== this.baseSupervisory.email ||
          this.projectModel.supervisory.isLocal !== this.baseSupervisory.isLocal) {
          // 修改
          Api.Company.updateCompany(this.projectModel.supervisory).then(() => {
            resolve()
          }).catch(err => {
            this.$Message.error('更新监理企业失败!' + err.message)
            reject(err)
          })
        } else {
          resolve()
        }
      })
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          console.log(1)
          await this.submitNewOwner()
          console.log(2)
          await this.submitNewContractor()
          console.log(3)
          await this.submitNewSupervisory()
          console.log(4)
          console.log(this.baseProject, this.projectModel.project)
          if (!this.baseProject || (this.projectModel.project.id !== this.baseProject.id || typeof(this.baseProject.id) === 'object' ||
            this.projectModel.project.name !== this.baseProject.name ||
            this.projectModel.project.type !== this.baseProject.type ||
            this.projectModel.project.filingNo !== this.baseProject.filingNo ||
            this.projectModel.project.planLicenseNo !== this.baseProject.planLicenseNo ||
            this.projectModel.project.constrLicenceNo !== this.baseProject.constrLicenceNo ||
            this.projectModel.project.area !== this.baseProject.area ||
            this.projectModel.project.cost !== this.baseProject.cost ||
            this.projectModel.project.site !== this.baseProject.site ||
            this.projectModel.project.startdate !== this.baseProject.startdate ||
            this.projectModel.project.finishdate !== this.baseProject.finishdate)) {
            this.loading = true
            this.$Spin.show()
            console.log(5)
            this.projectModel.project.cost = Math.round(this.projectModel.project.cost * 100)
            await Api.Project.addProject(this.projectModel.project)
              .then((payload) => {
                if (typeof(payload) === 'object') {
                  this.$Message.error('新增项目失败![数据模型错误]')
                  this.loading = false
                  this.$Spin.hide()
                  return false
                }
                console.log('suc', payload)
                this.projectModel.project.id = payload
                this.projectModel.prjId = payload
                this.$Message.success('新增项目成功!')
                this.loading = false
                this.$Spin.hide()
                this.$emit('finish-step3', this.projectModel)
              })
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
          } else {
            console.log(6)
            this.projectModel.project.cost = Math.round(this.projectModel.project.cost * 100)
            this.$emit('finish-step3', this.projectModel)
          }
        } else {
          console.log('err')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  .student-avatar {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
  }
}
</style>
